module.exports = __webpack_public_path__ + "img/app.367bb769.png";